import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["stage", "button"]
  static values = { background: String }

  connect() {
    let background = this.backgroundValue === "any" ? "grid" : this.backgroundValue
    try { background = localStorage.getItem("thuvien.ui.stageBg") || background } catch (_) { /* Optional preference. */ }
    this.apply(background)
    this.onChange = (event) => this.apply(event.detail.background)
    window.addEventListener("ui:stage-background", this.onChange)
  }

  disconnect() { window.removeEventListener("ui:stage-background", this.onChange) }

  choose(event) {
    const background = event.currentTarget.dataset.background
    try { localStorage.setItem("thuvien.ui.stageBg", background) } catch (_) { /* Optional preference. */ }
    window.dispatchEvent(new CustomEvent("ui:stage-background", { detail: { background } }))
  }

  apply(background) {
    if (!["dark", "light", "grid"].includes(background)) background = "dark"
    this.stageTarget.dataset.background = background
    this.buttonTargets.forEach((button) => button.setAttribute("aria-pressed", String(button.dataset.background === background)))
  }
}
